/**
 * React Query Keys
 */
export const QUERY_KEYS = {
    // Auth
    user: ['user'],

    // Equipment
    equipment: {
        all: ['equipment'],
        list: (filters: any) => ['equipment', 'list', filters],
        detail: (id: number | string) => ['equipment', 'detail', id],
        categories: ['equipment', 'categories'],
    },

    // Reports - Weekly
    weeklyReports: {
        all: ['weeklyReports'],
        list: (filters: any) => ['weeklyReports', 'list', filters],
        detail: (id: number | string) => ['weeklyReports', 'detail', id],
    },

    // Reports - Technical Assessments
    technicalAssessments: {
        all: ['technicalAssessments'],
        list: (filters: any) => ['technicalAssessments', 'list', filters],
        detail: (id: number | string) => ['technicalAssessments', 'detail', id],
    },

    // Reports - Parts Requisitions
    partsRequisitions: {
        all: ['partsRequisitions'],
        list: (filters: any) => ['partsRequisitions', 'list', filters],
        detail: (id: number | string) => ['partsRequisitions', 'detail', id],
        parts: ['parts'],
    },
};
